import { type ProviderEntitlementsForPatient } from '../graphQlTypes.generated';
import { UserSubscriptionType } from '../subscriptions';

export enum MembershipType {
  Owner = 'Owner',
  Guest = 'Guest',
  Shared = 'Shared',
}

export type RoomOwner = {
  id: string;
  title?: string | null;
  firstName: string;
  lastName: string;
  displayName?: string | null;
};

export type RoomOwnerForPatient = RoomOwner & {
  userProfilePictureUrl?: string | null;
  subscriptionType: UserSubscriptionType;
  legacyUserId?: string | null;
};

export type RoomV2 = {
  id: string;
  membershipType: MembershipType;
  slug: string;
  passcode?: string | null;
  isPasscodeEnabled: boolean;
  cameraOff: boolean;
  owner?: RoomOwner | null;
  sharedRoomDisplayName?: string | null;
};

export type NodeRoomV2 = {
  node: RoomV2;
};

export type RoomForPatient = {
  id: string;
  legacyId?: number | null;
  slug: string;
  passcode?: string | null;
  isPersonal: boolean;
  redirectUrl?: string | null;
  shouldRedirect?: boolean | null;
  checkInPhotoCapture?: boolean | null;
  owner?: RoomOwnerForPatient | null;
  sharedRoomDisplayName?: string | null;
  isPasscodeEnabled: boolean;
  tenantId?: string | null;
  providerEntitlements?: ProviderEntitlementsForPatient | null;
};
